/*
  Cart market guard — client half.

  The verdict is NOT computed here. sections/cart-market-guard.liquid decides,
  server-side, which cart lines cannot be bought in the shopper's market; this
  file only re-asks after a cart write and carries out the removal. Keeping the
  decision on the server is the point: a variant id posted straight to
  /cart/add.js never touches our page code, so page code cannot be the control.

  Triggers: first load, bfcache restore, and any fetch/XHR that writes the cart
  (/cart/add, /cart/change, /cart/update, /cart/clear). Kaching writes the cart
  through fetch, which is why fetch is wrapped rather than relying on our own
  form handlers.
*/
(function () {
  if (window.__efCartGuard) return;
  window.__efCartGuard = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var WRITE = /\/cart\/(add|change|update|clear)/i;
  var busy = false;

  function parseBlocked(raw) {
    if (!raw) return [];
    return raw.split('||').filter(Boolean).map(function (row) {
      var bits = row.split('~~');
      return { key: bits[0], title: bits[1] || 'An item' };
    });
  }

  var STASH = 'ef-cart-guard-msg';

  function message(titles) {
    var names = titles.filter(function (t, i, a) { return a.indexOf(t) === i; });
    return (
      names.join(' and ') +
      (names.length > 1 ? ' are' : ' is') +
      ' not available in your country, so ' +
      (names.length > 1 ? 'they have' : 'it has') +
      ' been removed from your cart.'
    );
  }

  function show(msg) {
    if (!msg) return;
    var el = document.createElement('div');
    el.className = 'ef-cart-guard-notice';
    el.setAttribute('role', 'status');
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.classList.add('is-going'); }, 7000);
    setTimeout(function () { el.remove(); }, 7600);
  }

  function check() {
    if (busy) return;
    busy = true;
    // Cache-buster: the Section Rendering API is edge-cached, and a stale verdict
    // here means a blocked line silently survives the very write that added it.
    fetch(ROOT + '?section_id=cart-market-guard&_=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.getElementById('ef-cart-guard-data');
        if (!node) return null;
        var data;
        try { data = JSON.parse(node.textContent); } catch (e) { return null; }
        var blocked = parseBlocked(data.blocked);
        if (!blocked.length) return null;

        var updates = {};
        blocked.forEach(function (b) { updates[b.key] = 0; });
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        }).then(function () { return blocked; });
      })
      .then(function (removed) {
        busy = false;
        if (!removed || !removed.length) return;
        var msg = message(removed.map(function (b) { return b.title; }));
        // Repaint whatever cart UI is on screen. Kaching and Dawn both listen
        // for their own events; a reload on the cart page is the only thing
        // guaranteed to be correct across both.
        //
        // The reload also wipes the notice, which would leave the shopper
        // watching items disappear with no explanation — worse than the bug.
        // So the message is stashed first and replayed on the way back in.
        if (/\/cart(\/|$|\?)/.test(location.pathname)) {
          try { sessionStorage.setItem(STASH, msg); } catch (e) {}
          location.reload();
        } else {
          show(msg);
          document.dispatchEvent(new CustomEvent('ef:cart-guard-removed'));
        }
      })
      .catch(function () { busy = false; });
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = arguments[0];
      var href = typeof url === 'string' ? url : (url && url.url) || '';
      return origFetch.apply(this, arguments).then(function (res) {
        if (WRITE.test(href)) setTimeout(check, 60);
        return res;
      });
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (WRITE.test(String(url || ''))) this.addEventListener('load', function () { setTimeout(check, 60); });
    return origOpen.apply(this, arguments);
  };

  function replay() {
    var msg = null;
    try { msg = sessionStorage.getItem(STASH); sessionStorage.removeItem(STASH); } catch (e) {}
    if (msg) show(msg);
  }

  function boot() { replay(); check(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
})();
